import EDC from '@/components/games/shared/globals';
import AvatarItem from './avatar-item';
import ScrollButton from './avatar-scroll-button';
import store from '@/store';

/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList = function (scene,
  parent, avatarsParent, avatarsUI, x, y) {
  this.scene = scene;
  this.parent = parent;
  this.avatarsParent = avatarsParent;
  this.avatarsUI = avatarsUI;
  this.x = x; // X center of the list (not including scroll bar and scroll buttons)
  this.y = y; // Y center of the list (not including scroll bar and scroll buttons)
  this.listWidth = 940;
  this.listHeight = 700;
  this.itemsInRow = 4;
  this.itemsInCol = 3;
  this.stepY = this.listHeight / this.itemsInCol;

  this.mask = null;

  this.buttonUp = null;
  this.buttonDown = null;
  this.scrollBarBg = null;
  this.scrollBarCarrage = null;
  this.scrollBarHeight = 0;
  this.scrollBarCarrageStepY = 0;
  this.currentScrollRow = 0;
  this.totalScrollRows = 0; // rows out of screen

  this.avatarsList = [];
  this.filtered = [];
  this.isBusy = false;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.create = function () {
  this.createButtons();
  this.createAvatars();
  this.alignAvatars(this.avatarsList);

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.getListAreaWidth = function () {
  return this.listWidth;
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.getListAreaHeight = function () {
  return this.listHeight;
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.createButtons = function () {
  this.scrollBarBg = this.scene.add.sprite(this.listWidth + 20, 50, 'list-scroll-bar-bg').setOrigin(0);

  this.scrollBarCarrage = this.scene.add.sprite(this.scrollBarBg.x, this.scrollBarBg.y, 'list-scroll-bar-caret').setOrigin(0);
  this.scrollBarCarrage.x = this.scrollBarBg.x + (
    this.scrollBarBg.displayWidth - this.scrollBarCarrage.displayWidth) / 2;
  this.scrollBarCarrage.y += 20;
  this.scrollBarCarrage.setData('topY', this.scrollBarCarrage.y);

  this.scrollBarHeight = this.scrollBarBg.height - (20 * 2) - this.scrollBarCarrage.height;

  this.avatarsUI.add([this.scrollBarBg, this.scrollBarCarrage]);

  this.buttonUp = new ScrollButton(this.scene,
    this.avatarsUI,
    this.scrollBarBg.x + this.scrollBarBg.displayWidth / 2, this.scrollBarBg.y + 15).create();
  this.buttonUp.setDepth(5);
  this.buttonUp.setUpCallback(this.scrollUp.bind(this));

  this.buttonDown = new ScrollButton(
    this.scene,
    this.avatarsUI,
    this.scrollBarBg.x + this.scrollBarBg.displayWidth / 2,
    this.scrollBarBg.y + this.scrollBarBg.displayHeight - 15,
  ).create();
  this.buttonDown.setDepth(5);
  this.buttonDown.rotate(180);
  this.buttonDown.setUpCallback(this.scrollDown.bind(this));
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.restoreScroll = function () {
  this.avatarsParent.y -= (this.stepY * this.parent.scaleY) * this.currentScrollRow;

  this.scrollBarCarrage.y = this.scrollBarCarrage.getData('topY');
  this.scrollBarCarrage.y += this.scrollBarCarrageStepY * this.currentScrollRow;
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.scrollDown = function () {
  if (this.isBusy) return;
  if (this.currentScrollRow >= this.totalScrollRows) {
    return;
  }
  this.buttonUp.disable(false);
  this.scene.tweens.add({
    targets: this.avatarsParent,
    y: this.avatarsParent.y - this.stepY * this.parent.scaleY,
    duration: 200,
    ease: 'Linear',
    onComplete: () => {
      this.isBusy = false;
    },
  });
  this.scrollBarCarrage.y += this.scrollBarCarrageStepY;
  this.isBusy = true;
  this.currentScrollRow += 1;
  if (this.currentScrollRow >= this.totalScrollRows) {
    this.buttonDown.disable(true);
  }
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.scrollUp = function () {
  if (this.isBusy) return;
  if (this.currentScrollRow <= 0) {
    this.buttonUp.disable(true);
    this.currentScrollRow = 0;
    return;
  }
  this.buttonDown.disable(false);
  this.scene.tweens.add({
    targets: this.avatarsParent,
    y: this.avatarsParent.y + this.stepY * this.parent.scaleY,
    duration: 200,
    ease: 'Linear',
    onComplete: () => {
      this.isBusy = false;
    },
  });
  this.scrollBarCarrage.y -= this.scrollBarCarrageStepY;
  this.isBusy = true;
  this.currentScrollRow -= 1;
  if (this.currentScrollRow <= 0) {
    this.buttonUp.disable(true);
  }
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.applyFilter = function (type) {
  this.avatarsList.forEach((elem) => {
    elem.removeFromParent();
  });

  this.filtered = this.avatarsList.filter((elem) => {
    if (type === 'all') {
      return elem;
    }
    if (elem.data.type === type) {
      return elem;
    }
    return elem;
  });
  this.filtered.forEach((elem) => {
    elem.addToParent();
  });
  const maxOnScreen = this.itemsInCol * this.itemsInRow;
  this.totalScrollRows = 0;
  if (this.filtered.length > maxOnScreen) {
    this.totalScrollRows = Math.ceil((this.filtered.length - maxOnScreen) / this.itemsInRow);
  }
  if (!this.totalScrollRows) {
    this.buttonDown.disable(true);
    this.buttonUp.disable(true);
  } else {
    this.buttonDown.disable(false);
    this.buttonUp.disable(true);
  }
  this.alignAvatars(this.filtered);
  this.resetPosition();
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.resetPosition = function () {
  this.currentScrollRow = 0;
  const baseX = this.avatarsParent.getData('baseX');
  const baseY = this.avatarsParent.getData('baseY');
  this.avatarsParent.setPosition(baseX, baseY);
  this.scrollBarCarrageStepY = (this.scrollBarHeight / this.totalScrollRows);
  this.scrollBarCarrage.y = this.scrollBarCarrage.getData('topY');
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.activateItem = function (id) {
  for (let i = 0; i < this.avatarsList.length; i++) {
    const avatar = this.avatarsList[i];
    if (avatar.data.id === id) {
      avatar.activate();
      return;
    }
  }
  this.avatarsList[0].activate();
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.createAvatars = function () {
  const activeAccount = store.getters['children/activeChildProfile'];
  const selectedGender = store.getters['children/newChildProfile'].gender;
  const gender = selectedGender || activeAccount.gender;
  let list = [];
  if (gender === 'boy' || gender === 'male') {
    list = this.scene.gameConfig.avatars.filter(avatar => avatar.gender === 'boy');
  } else if (gender === 'girl' || gender === 'female') {
    list = this.scene.gameConfig.avatars.filter(avatar => avatar.gender === 'girl');
  } else {
    list = this.scene.gameConfig.avatars;
  }

  for (let i = 0; i < list.length; i++) {
    const data = list[i];
    const item = new AvatarItem(this.scene, this.avatarsParent, 0, 0, data).create();
    this.avatarsList.push(item);
  }
};
/**
 *
 */
EDC.Games.AvatarSelect.AvatarsList.prototype.alignAvatars = function (list) {
  let currentRow = 0;
  let currentItem = 0;
  const stepX = this.listWidth / this.itemsInRow;

  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    const x = currentItem * stepX;
    const y = currentRow * this.stepY;
    item.place(x, y);

    currentItem += 1;
    if (currentItem >= this.itemsInRow) {
      currentRow += 1;
      currentItem = 0;
    }
  }
};

export default EDC.Games.AvatarSelect.AvatarsList;
